import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCreateEventSession, useUpdateEventSession } from 'actions/eventSessions';
import { addDays } from 'date-fns';
import getUtcDateTime from 'utils/timezone/getUtcDateTime';
import createLocation from 'utils/createLocation';
import filterObject from 'utils/filterObject';
import { getTimeInSeconds } from 'utils/times/getTimeInSeconds';
import { EditorPageStickySaveButton, EditorPageStickySaveDiscardButton } from 'components/EditorPageStickyFooter';
import EmptyStateController from 'components/EmptyStateController';
import UnsavedChangesBlockerModal from 'screens/UnsavedChangesBlockerModal';
import DetailsCard from './DetailsCard';
import useSessionForm from './useSessionForm';
import { sessionQueryParameters } from '../../utils';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function getTrimmedStringOrNull(value) {
  if (value === undefined) {
    return undefined;
  }
  return value.trim() || null;
}
function SessionDetailsPage(_ref) {
  var isNested = _ref.isNested,
    isLoading = _ref.isLoading,
    isError = _ref.isError,
    isEditMode = _ref.isEditMode,
    eventId = _ref.eventId,
    session = _ref.session;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var navigate = useNavigate();
  var form = useSessionForm({
    session: session
  });
  var fields = form.fields,
    reset = form.reset;
  var _useCreateEventSessio = useCreateEventSession({
      eventId: eventId
    }),
    createEventSession = _useCreateEventSessio.createEventSession,
    isCreatingSession = _useCreateEventSessio.isPending;
  var _useUpdateEventSessio = useUpdateEventSession({
      eventId: eventId
    }),
    updateEventSession = _useUpdateEventSessio.updateEventSession,
    isUpdatingSession = _useUpdateEventSessio.isPending;
  var isSaving = isCreatingSession || isUpdatingSession;
  var lastSessionIdRef = useRef(undefined);
  var pendingResetRef = useRef(false);
  useEffect(function () {
    var hasSessionIdChanged = (session === null || session === void 0 ? void 0 : session.id) !== lastSessionIdRef.current;
    if (hasSessionIdChanged) {
      lastSessionIdRef.current = session === null || session === void 0 ? void 0 : session.id;
      pendingResetRef.current = false;
    }
    if (!isEditMode || !(session !== null && session !== void 0 && session.id)) {
      pendingResetRef.current = false;
      return;
    }
    if (hasSessionIdChanged) {
      reset();
      return;
    }
    if (pendingResetRef.current && !isSaving) {
      pendingResetRef.current = false;
      reset();
    }
  }, [isEditMode, isSaving, reset, session === null || session === void 0 ? void 0 : session.id]);
  function handleSubmit(_x) {
    return _handleSubmit.apply(this, arguments);
  }
  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var date, startTime, endTime, timezone, locationField, reference, capacity, linkUrl, facilitator, joiningInstructions, formStartTime, startTimeInSeconds, endTimeInSeconds, endSpansNextDay, endDate, formEndTime, formLinkUrl, formReference, formFacilitator, formJoiningInstructions, _locationField$change, dateOrTimezoneChanged, startDateTimeChanged, endDateTimeChanged, createdSession;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            date = fields.date, startTime = fields.startTime, endTime = fields.endTime, timezone = fields.timezone, locationField = fields.location, reference = fields.reference, capacity = fields.capacity, linkUrl = fields.linkUrl, facilitator = fields.facilitator, joiningInstructions = fields.joiningInstructions;
            formStartTime = getUtcDateTime(date.value, startTime.value, timezone.value); // When end time is at or before start time (e.g. 23:00 start, 00:00 end),
            // the session spans midnight and the end falls on the next calendar day.
            startTimeInSeconds = getTimeInSeconds(startTime.value);
            endTimeInSeconds = getTimeInSeconds(endTime.value);
            endSpansNextDay = startTimeInSeconds !== null && endTimeInSeconds !== null && endTimeInSeconds <= startTimeInSeconds;
            endDate = endSpansNextDay ? addDays(new Date(date.value), 1).toISOString().slice(0, 10) : date.value;
            formEndTime = getUtcDateTime(endDate, endTime.value, timezone.value);
            formLinkUrl = getTrimmedStringOrNull(linkUrl.value);
            formReference = getTrimmedStringOrNull(reference.value);
            formFacilitator = getTrimmedStringOrNull(facilitator.value);
            formJoiningInstructions = getTrimmedStringOrNull(joiningInstructions.value);
            if (!(isEditMode && session !== null && session !== void 0 && session.id)) {
              _context.next = 2;
              break;
            }
            dateOrTimezoneChanged = date.wasChanged || timezone.wasChanged;
            startDateTimeChanged = dateOrTimezoneChanged || startTime.wasChanged;
            endDateTimeChanged = dateOrTimezoneChanged || endTime.wasChanged;
            _context.next = 1;
            return updateEventSession(_objectSpread({
              sessionId: session.id
            }, filterObject({
              startDateTime: startDateTimeChanged ? formStartTime : undefined,
              endDateTime: endDateTimeChanged ? formEndTime : undefined,
              timezone: timezone.changedValue,
              location: (_locationField$change = locationField.changedValue) === null || _locationField$change === void 0 ? void 0 : _locationField$change.trim(),
              reference: reference.wasChanged ? formReference : undefined,
              capacity: capacity.changedValue,
              linkUrl: linkUrl.wasChanged ? formLinkUrl : undefined,
              facilitator: facilitator.wasChanged ? formFacilitator : undefined,
              joiningInstructions: joiningInstructions.wasChanged ? formJoiningInstructions : undefined
            })));
          case 1:
            pendingResetRef.current = true;
            return _context.abrupt("return");
          case 2:
            _context.next = 3;
            return createEventSession({
              startDateTime: formStartTime,
              endDateTime: formEndTime,
              timezone: timezone.value,
              location: locationField.value.trim(),
              reference: formReference,
              capacity: capacity.value,
              linkUrl: formLinkUrl,
              facilitator: formFacilitator,
              joiningInstructions: formJoiningInstructions
            });
          case 3:
            createdSession = _context.sent;
            reset();
            navigate(createLocation(location, _defineProperty(_defineProperty({}, sessionQueryParameters.id, String(createdSession.id)), sessionQueryParameters.tab, 'details')), {
              replace: true
            });
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UnsavedChangesBlockerModal, {
      hasUnsavedChanges: form.wasChanged && !isSaving,
      includeQueryParams: true
    }), /*#__PURE__*/_jsx(EmptyStateController, {
      isLoading: isLoading,
      isError: isError,
      showContentInCards: true,
      height: 250,
      children: /*#__PURE__*/_jsxs("form", {
        onSubmit: handleSubmit,
        children: [/*#__PURE__*/_jsx(DetailsCard, {
          isNested: isNested,
          fields: fields
        }), isEditMode ? /*#__PURE__*/_jsx(EditorPageStickySaveDiscardButton, {
          cardVariant: "raised",
          buttonText: t('actions_save_changes'),
          hasChanges: form.wasChanged,
          isDisabled: form.hasErrors,
          isSaving: isSaving,
          onDiscard: reset
        }) : /*#__PURE__*/_jsx(EditorPageStickySaveButton, {
          isDisabled: form.hasErrors,
          isLoading: isSaving,
          buttonText: t('actions_save')
        })]
      })
    })]
  });
}
export default SessionDetailsPage;